export default __webpack_public_path__ + "static/media/Gabriela Caseff.ec7c5a6b.png";